import clsx from 'clsx';
import Link from 'next/link';

export default function AdminEditButton({
  adminPath,
  isEditorial,
}: {
  adminPath: string;
  isEditorial?: boolean;
}) {
  return (
    <div
      className={clsx(
        'w-[32px] h-[32px] rounded-full text-sm flex hover:bg-orange-400 relative bg-[#888] border-[1px]',
        isEditorial ? 'border-orange-400' : 'border-[#888]'
      )}
    >
      <Link
        href={`/admin/${adminPath}`}
        rel="noreferrer"
        className="absolute top-0 left-0 w-full h-full p-[6px] fill-white"
      >
        <svg version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <path d="m69.586 15.645c-1.0586-0.31641-2.2031-0.027343-2.9844 0.75391l-48.086 48.098h-0.003906c-0.45312 0.45703-0.74609 1.0508-0.83984 1.6875l-2.1055 14.867c-0.13672 0.93359 0.17969 1.8789 0.84375 2.5469 0.66797 0.66797 1.6133 0.98438 2.5469 0.85156l14.84-2.1367c0.64844-0.085938 1.25-0.37891 1.7148-0.83594l48.086-48.098v-0.003906c0.55859-0.56641 0.87109-1.332 0.86719-2.1289-0.003906-0.79297-0.32812-1.5547-0.89453-2.1133l-12.703-12.723c-0.35547-0.35938-0.79688-0.62109-1.2812-0.76562zm-0.84766 7.1484 8.4688 8.4805-45.258 45.266-9.8867 1.3945 1.4258-9.9062z" />
        </svg>
      </Link>
    </div>
  );
}
